import { render, staticRenderFns } from "./admin_sylb.vue?vue&type=template&id=608f9c70&scoped=true"
import script from "./admin_sylb.vue?vue&type=script&lang=js"
export * from "./admin_sylb.vue?vue&type=script&lang=js"
import style0 from "./admin_sylb.vue?vue&type=style&index=0&id=608f9c70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608f9c70",
  null
  
)

export default component.exports